<template>
  <div>
    <vue-phone-number-input
      v-model="localValue"
      :color="'#f4b452'"
      :valid-color="'#207468'"
      :error-color="'#b7202e'"
      :default-country-code="data.countryCode"
      placeholder="Test"
      class="phoneInput"
      @update="update"
    />
  </div>
</template>

<script>
import VuePhoneNumberInput from 'vue-phone-number-input'
import 'vue-phone-number-input/dist/vue-phone-number-input.css'
import { countries } from '@/plugins/phoneCountries'

export default {
  name: "PhoneInput",
  components: {
    VuePhoneNumberInput
  },
  props: {
    data: {
      type: Object,
      required: false,
      default: () => ({
        countryCode: undefined,
        localValue: undefined
      })
    }
  },
  data: () => ({
    countryCode: null,
    localValue: null
  }),
  watch: {
    data: {
      immediate: true,
      deep: true,
      handler(newVal) {
        const country = countries.filter(country => country.iso2 === newVal.countryCode)[0]
        this.countryCode = newVal.countryCode ? newVal.countryCode : null
        this.localValue = newVal.localValue ? newVal.localValue.replace('+' + country['dialCode'], '') : null
      }
    }
  },
  methods: {
    update(event) {
      this.$emit('update', event)
    }
  }
}
</script>

<style lang="scss">
$c: '.phoneInput';

#{$c} {
  width: 100%;
  input {
    font-size: inherit !important;
    line-height: 40px !important;
    height: 40px !important;
  }

  .select-country-container {
    flex: 0 0 100px;
    min-width: 100px;
  }

  .field-label {
    display: none;
  }

  .field.vue-input-ui.has-value .field-input {
    padding-top: 0 !important;
  }

  #VuePhoneNumberInput_country_selector {
    display: flex;
    align-items: center;
    padding-top: 0;
    padding-bottom: 0;
  }

  .country-selector-arrow {
    top: 0;
  }

  .country-selector .field-country-flag {
    top: 50%;
    transform: translateY(-50%);
  }
}
</style>